import React, { useState, useEffect } from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import CopyRight from "../../Student/Reusablecomponents/Copyright";
import { Outlet } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

const QBReports = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [SPages, SetSPages] = useState("WQC");
  const Navigate = (e) => {
    SetSPages(e);
    if (e === "WQC") {
      navigate("/NCLAdmin/QBReports/WeeklyOverallQuestions");
    } else {
      navigate("/NCLAdmin/QBReports/QuestionStatusTrack");
    }
  };
  // useEffect(()=>{navigate("/NCLAdmin/QBReports/WeeklyOverallQuestions")},[])
  useEffect(() => {
    Navigate(location?.state?.Tab || "WQC");
  }, [location?.state?.Tab]);
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="dflex gap-3 JCCenter">
          {["WQC", "QST"].map((item) => (
            <div className="dflex gap-2">
              <input
                type="radio"
                name="QBReports"
                checked={item === SPages}
                onClick={() => Navigate(item)}
              />
              {item === "WQC"
                ? "Overall/Weekly QC Status"
                : "Question Status Track"}
            </div>
          ))}
        </div>
        <Outlet />
        {/* <CopyRight /> */}
      </div>
    </>
  );
};

export default QBReports;
